export default "__VITE_ASSET__DgLAhQHf__"